import { render, staticRenderFns } from "./CourseFolder.vue?vue&type=template&id=8a9f4f7c&"
import script from "./CourseFolder.vue?vue&type=script&lang=js&"
export * from "./CourseFolder.vue?vue&type=script&lang=js&"
import style0 from "./CourseFolder.vue?vue&type=style&index=0&id=8a9f4f7c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports